module.exports = __webpack_public_path__ + "images/FUSA_icons/068-shopping-cart-1.2befee3081ae64fa4a08f68863596f05.svg";